import { render, staticRenderFns } from "./DatatableSearchClients.vue?vue&type=template&id=d7526bb8&"
import script from "./DatatableSearchClients.vue?vue&type=script&lang=js&"
export * from "./DatatableSearchClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7526bb8')) {
      api.createRecord('d7526bb8', component.options)
    } else {
      api.reload('d7526bb8', component.options)
    }
    module.hot.accept("./DatatableSearchClients.vue?vue&type=template&id=d7526bb8&", function () {
      api.rerender('d7526bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configurations/Widgets/DatatableSearchClients.vue"
export default component.exports